"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/recurring-transfer.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Frecurring-transfer.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferScheduleMonthlyDayOfMonthToJSON = exports.transferScheduleMonthlyDayOfMonthFromJSON = exports.transferScheduleMonthlyTwiceStartOnDayToJSON = exports.transferScheduleMonthlyTwiceStartOnDayFromJSON = exports.recurringTransferStatusToJSON = exports.recurringTransferStatusFromJSON = exports.RecurringTransferChangelog = exports.RecurringTransfer = exports.TransferScheduleMonthly = exports.TransferScheduleMonthlyTwice = exports.TransferScheduleWeekly = exports.TransferSchedule = exports.TransferScheduleMonthlyDayOfMonth = exports.TransferScheduleMonthlyTwiceStartOnDay = exports.RecurringTransferStatus = void 0;
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const recurring_transfer_date_1 = require("./recurring-transfer-date");
const send_money_1 = require("./send-money");
const transfer_instructions_1 = require("./transfer-instructions");
const protobufPackage = 'com.step.transfer.proto';
var RecurringTransferStatus;
(function (RecurringTransferStatus) {
    RecurringTransferStatus["INVALID_STATUS"] = "INVALID_STATUS";
    /**
     * ENABLED - Recurring transfer enabled.
     */
    RecurringTransferStatus["ENABLED"] = "ENABLED";
    /**
     * DISABLED - Recurring transfer disabled.
     */
    RecurringTransferStatus["DISABLED"] = "DISABLED";
    /**
     * DELETED - Recurring transfer deleted.
     */
    RecurringTransferStatus["DELETED"] = "DELETED";
    RecurringTransferStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RecurringTransferStatus || (exports.RecurringTransferStatus = RecurringTransferStatus = {}));
var TransferScheduleMonthlyTwiceStartOnDay;
(function (TransferScheduleMonthlyTwiceStartOnDay) {
    TransferScheduleMonthlyTwiceStartOnDay["INVALID_DAY_OF_MONTH"] = "INVALID_DAY_OF_MONTH";
    TransferScheduleMonthlyTwiceStartOnDay["FIRST"] = "FIRST";
    TransferScheduleMonthlyTwiceStartOnDay["FIFTEENTH"] = "FIFTEENTH";
    TransferScheduleMonthlyTwiceStartOnDay["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferScheduleMonthlyTwiceStartOnDay || (exports.TransferScheduleMonthlyTwiceStartOnDay = TransferScheduleMonthlyTwiceStartOnDay = {}));
var TransferScheduleMonthlyDayOfMonth;
(function (TransferScheduleMonthlyDayOfMonth) {
    TransferScheduleMonthlyDayOfMonth["INVALID_DAY_OF_MONTH"] = "INVALID_DAY_OF_MONTH";
    TransferScheduleMonthlyDayOfMonth["FIRST"] = "FIRST";
    TransferScheduleMonthlyDayOfMonth["FIFTEENTH"] = "FIFTEENTH";
    TransferScheduleMonthlyDayOfMonth["LAST"] = "LAST";
    TransferScheduleMonthlyDayOfMonth["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferScheduleMonthlyDayOfMonth || (exports.TransferScheduleMonthlyDayOfMonth = TransferScheduleMonthlyDayOfMonth = {}));
function createBaseTransferSchedule() {
    return { weekly: undefined, monthly: undefined, monthlyTwice: undefined };
}
exports.TransferSchedule = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.weekly)) {
            message.weekly = exports.TransferScheduleWeekly.fromJSON(object.weekly);
        }
        if (isSet(object.monthly)) {
            message.monthly = exports.TransferScheduleMonthly.fromJSON(object.monthly);
        }
        if (isSet(object.monthlyTwice)) {
            message.monthlyTwice = exports.TransferScheduleMonthlyTwice.fromJSON(object.monthlyTwice);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.weekly !== undefined) {
            obj.weekly = exports.TransferScheduleWeekly.toJSON(message.weekly);
        }
        if (message.monthly !== undefined) {
            obj.monthly = exports.TransferScheduleMonthly.toJSON(message.monthly);
        }
        if (message.monthlyTwice !== undefined) {
            obj.monthlyTwice = exports.TransferScheduleMonthlyTwice.toJSON(message.monthlyTwice);
        }
        return obj;
    },
    create(base) {
        return exports.TransferSchedule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSchedule();
        message.weekly = (object.weekly !== undefined && object.weekly !== null)
            ? exports.TransferScheduleWeekly.fromPartial(object.weekly)
            : undefined;
        message.monthly = (object.monthly !== undefined && object.monthly !== null)
            ? exports.TransferScheduleMonthly.fromPartial(object.monthly)
            : undefined;
        message.monthlyTwice = (object.monthlyTwice !== undefined && object.monthlyTwice !== null)
            ? exports.TransferScheduleMonthlyTwice.fromPartial(object.monthlyTwice)
            : undefined;
        return message;
    },
};
function createBaseTransferScheduleWeekly() {
    return { dayOfWeek: 0 };
}
exports.TransferScheduleWeekly = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.dayOfWeek)) {
            message.dayOfWeek = globalThis.Number(object.dayOfWeek);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dayOfWeek !== undefined && message.dayOfWeek !== 0) {
            obj.dayOfWeek = Math.round(message.dayOfWeek);
        }
        return obj;
    },
    create(base) {
        return exports.TransferScheduleWeekly.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferScheduleWeekly();
        message.dayOfWeek = object.dayOfWeek ?? 0;
        return message;
    },
};
function createBaseTransferScheduleMonthlyTwice() {
    return { startOnDay: TransferScheduleMonthlyTwiceStartOnDay.INVALID_DAY_OF_MONTH };
}
exports.TransferScheduleMonthlyTwice = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.startOnDay)) {
            message.startOnDay = transferScheduleMonthlyTwiceStartOnDayFromJSON(object.startOnDay);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.startOnDay !== undefined &&
            message.startOnDay !== TransferScheduleMonthlyTwiceStartOnDay.INVALID_DAY_OF_MONTH) {
            obj.startOnDay = transferScheduleMonthlyTwiceStartOnDayToJSON(message.startOnDay);
        }
        return obj;
    },
    create(base) {
        return exports.TransferScheduleMonthlyTwice.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferScheduleMonthlyTwice();
        message.startOnDay = object.startOnDay ??
            TransferScheduleMonthlyTwiceStartOnDay.INVALID_DAY_OF_MONTH;
        return message;
    },
};
function createBaseTransferScheduleMonthly() {
    return { dayOfMonth: undefined, day: undefined };
}
exports.TransferScheduleMonthly = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.dayOfMonth)) {
            message.dayOfMonth = transferScheduleMonthlyDayOfMonthFromJSON(object.dayOfMonth);
        }
        if (isSet(object.day)) {
            message.day = globalThis.Number(object.day);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dayOfMonth !== undefined) {
            obj.dayOfMonth = transferScheduleMonthlyDayOfMonthToJSON(message.dayOfMonth);
        }
        if (message.day !== undefined) {
            obj.day = Math.round(message.day);
        }
        return obj;
    },
    create(base) {
        return exports.TransferScheduleMonthly.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferScheduleMonthly();
        message.dayOfMonth = object.dayOfMonth ?? undefined;
        message.day = object.day ?? undefined;
        return message;
    },
};
function createBaseRecurringTransfer() {
    return {
        id: '',
        from: send_money_1.TransferFrom.fromPartial({}),
        to: send_money_1.TransferTo.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        description: '',
        instructions: undefined,
        counterpartyUserId: '',
        schedule: exports.TransferSchedule.fromPartial({}),
        enabled: false,
        nextTransfer: undefined,
        lastTransfer: undefined,
        nextInitiateAt: undefined,
        upcomingTransferDates: [],
        status: RecurringTransferStatus.INVALID_STATUS,
        inProgressTransferDates: [],
    };
}
exports.RecurringTransfer = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            from: isSet(object.from) ? send_money_1.TransferFrom.fromJSON(object.from) : send_money_1.TransferFrom.fromPartial({}),
            to: isSet(object.to) ? send_money_1.TransferTo.fromJSON(object.to) : send_money_1.TransferTo.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            schedule: isSet(object.schedule)
                ? exports.TransferSchedule.fromJSON(object.schedule)
                : exports.TransferSchedule.fromPartial({}),
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
            upcomingTransferDates: globalThis.Array.isArray(object?.upcomingTransferDates)
                ? object.upcomingTransferDates.map((e) => recurring_transfer_date_1.RecurringTransferDate.fromJSON(e))
                : [],
            inProgressTransferDates: globalThis.Array.isArray(object?.inProgressTransferDates)
                ? object.inProgressTransferDates.map((e) => recurring_transfer_date_1.RecurringTransferDate.fromJSON(e))
                : [],
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.instructions)) {
            message.instructions = transfer_instructions_1.TransferInstructions.fromJSON(object.instructions);
        }
        if (isSet(object.counterpartyUserId)) {
            message.counterpartyUserId = globalThis.String(object.counterpartyUserId);
        }
        if (isSet(object.nextTransfer)) {
            message.nextTransfer = date_1.DateMessage.fromJSON(object.nextTransfer);
        }
        if (isSet(object.lastTransfer)) {
            message.lastTransfer = date_1.DateMessage.fromJSON(object.lastTransfer);
        }
        if (isSet(object.nextInitiateAt)) {
            message.nextInitiateAt = date_1.DateMessage.fromJSON(object.nextInitiateAt);
        }
        if (isSet(object.status)) {
            message.status = recurringTransferStatusFromJSON(object.status);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.from !== undefined) {
            obj.from = send_money_1.TransferFrom.toJSON(message.from);
        }
        if (message.to !== undefined) {
            obj.to = send_money_1.TransferTo.toJSON(message.to);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.instructions !== undefined) {
            obj.instructions = transfer_instructions_1.TransferInstructions.toJSON(message.instructions);
        }
        if (message.counterpartyUserId !== undefined && message.counterpartyUserId !== '') {
            obj.counterpartyUserId = message.counterpartyUserId;
        }
        if (message.schedule !== undefined) {
            obj.schedule = exports.TransferSchedule.toJSON(message.schedule);
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        if (message.nextTransfer !== undefined) {
            obj.nextTransfer = date_1.DateMessage.toJSON(message.nextTransfer);
        }
        if (message.lastTransfer !== undefined) {
            obj.lastTransfer = date_1.DateMessage.toJSON(message.lastTransfer);
        }
        if (message.nextInitiateAt !== undefined) {
            obj.nextInitiateAt = date_1.DateMessage.toJSON(message.nextInitiateAt);
        }
        if (message.upcomingTransferDates?.length) {
            obj.upcomingTransferDates = message.upcomingTransferDates.map((e) => recurring_transfer_date_1.RecurringTransferDate.toJSON(e));
        }
        if (message.status !== undefined && message.status !== RecurringTransferStatus.INVALID_STATUS) {
            obj.status = recurringTransferStatusToJSON(message.status);
        }
        if (message.inProgressTransferDates?.length) {
            obj.inProgressTransferDates = message.inProgressTransferDates.map((e) => recurring_transfer_date_1.RecurringTransferDate.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransfer();
        message.id = object.id ?? '';
        message.from = (object.from !== undefined && object.from !== null)
            ? send_money_1.TransferFrom.fromPartial(object.from)
            : send_money_1.TransferFrom.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? send_money_1.TransferTo.fromPartial(object.to)
            : send_money_1.TransferTo.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        message.instructions = (object.instructions !== undefined && object.instructions !== null)
            ? transfer_instructions_1.TransferInstructions.fromPartial(object.instructions)
            : undefined;
        message.counterpartyUserId = object.counterpartyUserId ?? '';
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? exports.TransferSchedule.fromPartial(object.schedule)
            : exports.TransferSchedule.fromPartial({});
        message.enabled = object.enabled ?? false;
        message.nextTransfer = (object.nextTransfer !== undefined && object.nextTransfer !== null)
            ? date_1.DateMessage.fromPartial(object.nextTransfer)
            : undefined;
        message.lastTransfer = (object.lastTransfer !== undefined && object.lastTransfer !== null)
            ? date_1.DateMessage.fromPartial(object.lastTransfer)
            : undefined;
        message.nextInitiateAt = (object.nextInitiateAt !== undefined && object.nextInitiateAt !== null)
            ? date_1.DateMessage.fromPartial(object.nextInitiateAt)
            : undefined;
        message.upcomingTransferDates =
            object.upcomingTransferDates?.map((e) => recurring_transfer_date_1.RecurringTransferDate.fromPartial(e)) || [];
        message.status = object.status ?? RecurringTransferStatus.INVALID_STATUS;
        message.inProgressTransferDates =
            object.inProgressTransferDates?.map((e) => recurring_transfer_date_1.RecurringTransferDate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRecurringTransferChangelog() {
    return { transfer: exports.RecurringTransfer.fromPartial({}), createdAtMs: '0' };
}
exports.RecurringTransferChangelog = {
    fromJSON(object) {
        const message = {
            transfer: isSet(object.transfer)
                ? exports.RecurringTransfer.fromJSON(object.transfer)
                : exports.RecurringTransfer.fromPartial({}),
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfer !== undefined) {
            obj.transfer = exports.RecurringTransfer.toJSON(message.transfer);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferChangelog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferChangelog();
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? exports.RecurringTransfer.fromPartial(object.transfer)
            : exports.RecurringTransfer.fromPartial({});
        message.createdAtMs = object.createdAtMs ?? '0';
        return message;
    },
};
function recurringTransferStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STATUS':
            return RecurringTransferStatus.INVALID_STATUS;
        case 1:
        case 'ENABLED':
            return RecurringTransferStatus.ENABLED;
        case 2:
        case 'DISABLED':
            return RecurringTransferStatus.DISABLED;
        case 3:
        case 'DELETED':
            return RecurringTransferStatus.DELETED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RecurringTransferStatus.UNRECOGNIZED;
    }
}
exports.recurringTransferStatusFromJSON = recurringTransferStatusFromJSON;
function recurringTransferStatusToJSON(object) {
    switch (object) {
        case RecurringTransferStatus.INVALID_STATUS:
            return 'INVALID_STATUS';
        case RecurringTransferStatus.ENABLED:
            return 'ENABLED';
        case RecurringTransferStatus.DISABLED:
            return 'DISABLED';
        case RecurringTransferStatus.DELETED:
            return 'DELETED';
        case RecurringTransferStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.recurringTransferStatusToJSON = recurringTransferStatusToJSON;
function transferScheduleMonthlyTwiceStartOnDayFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DAY_OF_MONTH':
            return TransferScheduleMonthlyTwiceStartOnDay.INVALID_DAY_OF_MONTH;
        case 1:
        case 'FIRST':
            return TransferScheduleMonthlyTwiceStartOnDay.FIRST;
        case 2:
        case 'FIFTEENTH':
            return TransferScheduleMonthlyTwiceStartOnDay.FIFTEENTH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferScheduleMonthlyTwiceStartOnDay.UNRECOGNIZED;
    }
}
exports.transferScheduleMonthlyTwiceStartOnDayFromJSON = transferScheduleMonthlyTwiceStartOnDayFromJSON;
function transferScheduleMonthlyTwiceStartOnDayToJSON(object) {
    switch (object) {
        case TransferScheduleMonthlyTwiceStartOnDay.INVALID_DAY_OF_MONTH:
            return 'INVALID_DAY_OF_MONTH';
        case TransferScheduleMonthlyTwiceStartOnDay.FIRST:
            return 'FIRST';
        case TransferScheduleMonthlyTwiceStartOnDay.FIFTEENTH:
            return 'FIFTEENTH';
        case TransferScheduleMonthlyTwiceStartOnDay.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferScheduleMonthlyTwiceStartOnDayToJSON = transferScheduleMonthlyTwiceStartOnDayToJSON;
function transferScheduleMonthlyDayOfMonthFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DAY_OF_MONTH':
            return TransferScheduleMonthlyDayOfMonth.INVALID_DAY_OF_MONTH;
        case 1:
        case 'FIRST':
            return TransferScheduleMonthlyDayOfMonth.FIRST;
        case 2:
        case 'FIFTEENTH':
            return TransferScheduleMonthlyDayOfMonth.FIFTEENTH;
        case 3:
        case 'LAST':
            return TransferScheduleMonthlyDayOfMonth.LAST;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferScheduleMonthlyDayOfMonth.UNRECOGNIZED;
    }
}
exports.transferScheduleMonthlyDayOfMonthFromJSON = transferScheduleMonthlyDayOfMonthFromJSON;
function transferScheduleMonthlyDayOfMonthToJSON(object) {
    switch (object) {
        case TransferScheduleMonthlyDayOfMonth.INVALID_DAY_OF_MONTH:
            return 'INVALID_DAY_OF_MONTH';
        case TransferScheduleMonthlyDayOfMonth.FIRST:
            return 'FIRST';
        case TransferScheduleMonthlyDayOfMonth.FIFTEENTH:
            return 'FIFTEENTH';
        case TransferScheduleMonthlyDayOfMonth.LAST:
            return 'LAST';
        case TransferScheduleMonthlyDayOfMonth.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferScheduleMonthlyDayOfMonthToJSON = transferScheduleMonthlyDayOfMonthToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=recurring-transfer.js.map